// Game.js
import React, { useState, useEffect } from 'react';
import { useSwipeable } from 'react-swipeable';

const GRID_SIZE = 8;
const CELL_SIZE = 40;


// Direction constants
const DIRECTIONS = {
  RIGHT: { x: 1, y: 0 },
  LEFT: { x: -1, y: 0 },
  UP: { x: 0, y: -1 },
  DOWN: { x: 0, y: 1 },
};

const DIRECTION_LIST = [DIRECTIONS.RIGHT, DIRECTIONS.LEFT, DIRECTIONS.UP, DIRECTIONS.DOWN];

const Game = () => {

  const [playerPosition, setPlayerPosition] = useState({ x: 0, y: 0 });
  const [aiPosition, setAiPosition] = useState({ x: Math.floor(Math.random() * GRID_SIZE), y: Math.floor(Math.random() * GRID_SIZE) });
  const [carolinePosition, setCarolinePosition] = useState({ x: Math.floor(Math.random() * GRID_SIZE), y: Math.floor(Math.random() * GRID_SIZE) });
  const [currentDirection, setCurrentDirection] = useState(DIRECTIONS.RIGHT);

  const [jbgCaught, setJbgCaught] = useState(false);
  const [jbgEscaped, setJbgEscaped] = useState(false);
  const [speedBoost, setSpeedBoost] = useState([false, 0]);

  const [tick, setTick] = useState(0);

  const interval = 350;

  // Calculate distance between two points
  const getDistance = (pos1, pos2) => {
    return Math.sqrt(Math.pow(pos1.x - pos2.x, 2) + Math.pow(pos1.y - pos2.y, 2));
  };

  useEffect(() => {
    const tickInterval = setInterval(() => {
      setTick(prevTick => prevTick + 1);
    }, interval);

    

    return () => clearInterval(tickInterval);
  }, [interval]);

  useEffect(() => {


    // each tick, 2% chance of escaping
    if (jbgCaught) {
        if (Math.random() < 0.02) {
            restartGame();
        }
    }

    }, [tick]);



  // Movement
  useEffect(() => {
    if (jbgCaught) return;

    if (tick - speedBoost[1] >= 5) {
        setSpeedBoost([false, tick]);
    }

    // get the next player position
    const nextPlayerPosition = {
        x: playerPosition.x + (currentDirection.x * (speedBoost[0] ? 2 : 1)),
        y: playerPosition.y + (currentDirection.y * (speedBoost[0] ? 2 : 1)),
    };

    // check for wall collisions
    if (nextPlayerPosition.x < 0 || nextPlayerPosition.x >= GRID_SIZE || nextPlayerPosition.y < 0 || nextPlayerPosition.y >= GRID_SIZE) {
        
        nextPlayerPosition.x = playerPosition.x - currentDirection.x;
        nextPlayerPosition.y = playerPosition.y - currentDirection.y;

        // bounce them off the wall
        setCurrentDirection({
            x: -currentDirection.x,
            y: -currentDirection.y,
        });
    }

    // check if the player is currently on the AI
    // or will be on the AI in the next move
    const playerCurrentlyOnAI = playerPosition.x === aiPosition.x && playerPosition.y === aiPosition.y;
    const playerNextOnAI = nextPlayerPosition.x === aiPosition.x && nextPlayerPosition.y === aiPosition.y;

    if (playerCurrentlyOnAI || playerNextOnAI) {
          // Randomly relocate AI
          setJbgCaught(true);
          return;
          /* setAiPosition({
            x: Math.floor(Math.random() * GRID_SIZE),
            y: Math.floor(Math.random() * GRID_SIZE),
          }); */
    }

    // check if the player will be on Caroline in the next move
    const playerNextOnCaroline = nextPlayerPosition.x === carolinePosition.x && nextPlayerPosition.y === carolinePosition.y;

    if (playerNextOnCaroline) {
        setSpeedBoost([true, tick]);
        setCarolinePosition({
            x: Math.floor(Math.random() * GRID_SIZE),
            y: Math.floor(Math.random() * GRID_SIZE),
        });
    }

    // player movement
    setPlayerPosition(nextPlayerPosition);

    // AI movement
    setAiPosition(prevPos => {
        // Get all possible moves
        const possibleMoves = DIRECTION_LIST
            .map(dir => ({
            x: prevPos.x + dir.x,
            y: prevPos.y + dir.y,
            }))
            .filter(pos => 
            pos.x >= 0 && pos.x < GRID_SIZE && 
            pos.y >= 0 && pos.y < GRID_SIZE
            );

        // Find the move that maximizes distance from player
        let bestMove = prevPos;
        let maxDistance = getDistance(prevPos, playerPosition);

        possibleMoves.forEach(move => {
            const distance = getDistance(move, playerPosition);
            if (distance > maxDistance) {
            maxDistance = distance;
            bestMove = move;
            }
        });

        // Sometimes make a random move to make AI less predictable
        if (Math.random() < 0.2) {
            const randomMove = possibleMoves[Math.floor(Math.random() * possibleMoves.length)];
            return randomMove;
        }

        return bestMove;
    });

  }, [tick]);

  // Handle swipe gestures
  const handlers = useSwipeable({
    onSwipedLeft: () => {
        setCurrentDirection(DIRECTIONS.LEFT);
    },
    onSwipedRight: () => {
        setCurrentDirection(DIRECTIONS.RIGHT);
    },
    onSwipedUp: () => {
        setCurrentDirection(DIRECTIONS.UP);
    },
    onSwipedDown: () => {
        setCurrentDirection(DIRECTIONS.DOWN);
    },
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  // Keyboard controls
  useEffect(() => {
    const handleKeyPress = (e) => {
      switch (e.key) {
        case 'ArrowLeft':
            setCurrentDirection(DIRECTIONS.LEFT);
            break;
        case 'ArrowRight':
            setCurrentDirection(DIRECTIONS.RIGHT);
            break;
        case 'ArrowUp':
            setCurrentDirection(DIRECTIONS.UP);
            break;
        case 'ArrowDown':
            setCurrentDirection(DIRECTIONS.DOWN);
            break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [currentDirection]);

  const restartGame = () => {
    setPlayerPosition({ x: 0, y: 0 });
    setAiPosition({ x: Math.floor(Math.random() * GRID_SIZE), y: Math.floor(Math.random() * GRID_SIZE) });
    setCarolinePosition({ x: Math.floor(Math.random() * GRID_SIZE), y: Math.floor(Math.random() * GRID_SIZE) });
    setCurrentDirection(DIRECTIONS.RIGHT);
    setJbgCaught(false);
    setJbgEscaped(true);
  };

  return (
    <div 
    className='game-container'
    >
        <div
        className='game-text'>
            {jbgCaught ? 'Got him!' : jbgEscaped ? 'He escaped!' : 'Catch Jimmy Bad Guy!!!'}
        </div>

      <div
        {...handlers}
        style={{
          position: 'relative',
          width: GRID_SIZE * CELL_SIZE,
          height: GRID_SIZE * CELL_SIZE,
          //border: '1px solid black',
          backgroundColor: '#fff1e0',
          touchAction: 'none',
          boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        {/* Player */}
        <img
          style={{
            position: 'absolute',
            left: playerPosition.x * CELL_SIZE,
            top: playerPosition.y * CELL_SIZE,
            width: CELL_SIZE,
            height: CELL_SIZE,
            borderRadius: '50%',
            transition: 'all 0.1s',
            zIndex: 2
          }}
            src='assets/mikeyandeleanor.png'
        >
        </img>

        {/* JBG */}
        <img
          style={{
            position: 'absolute',
            left: aiPosition.x * CELL_SIZE,
            top: aiPosition.y * CELL_SIZE,
            width: CELL_SIZE,
            height: CELL_SIZE,
            borderRadius: '50%',
            transition: 'all 0.1s',
            zIndex: 1
          }}
          src='assets/jimmy-bad-guy.png'
        />

        {/* Caroline */}
        <img
          style={{
            position: 'absolute',
            left: carolinePosition.x * CELL_SIZE,
            top: carolinePosition.y * CELL_SIZE,
            width: CELL_SIZE,
            height: CELL_SIZE,
            borderRadius: '50%',
            transition: 'all 0.1s',
            zIndex: 1,
            opacity: speedBoost[0] ? 0 : 1
          }}
          src='assets/caroline.jpg'
        />
      
      </div>

      {speedBoost[0] && (
        <div
        className='game-text'
        style={{
          color: 'red'
        }}
        >
          Speed Boost!
        </div>
      )}

      <div
      style={{
        paddingBottom: '100px',
        opacity: jbgCaught ? 1 : 0,
      }}

      >
        <img

        src='assets/jimmy-bad-guy-jail.png'
        style={{
            width: '50%',
            height: 'auto'
        }}
        >
        </img>


      </div>
    
    </div>
  );
};

export default Game;
